import { defineStore } from 'pinia';
import { ref } from 'vue';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';
import { httpsCallable, getFunctions } from 'firebase/functions';
import { db, app } from '../lib/firebase';

export const useReportsStore = defineStore('reports', () => {
  const reports = ref([]);
  const loading = ref(false);
  let unsub = null;

  function bind() {
    if (unsub) return;
    loading.value = true;
    const q = query(collection(db, 'bug_reports'), orderBy('createdAt', 'desc'));
    unsub = onSnapshot(
      q,
      (snap) => {
        reports.value = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        loading.value = false;
      },
      (err) => { console.error('[reports] list error', err); loading.value = false; }
    );
  }

  function unbind() {
    if (unsub) { unsub(); unsub = null; }
  }

  function callable(name, opts) {
    // europe-west1, coherent avec le reste de l'app (cf. stores/stock.js).
    const fn = getFunctions(app, 'europe-west1');
    return httpsCallable(fn, name, opts);
  }

  async function submitReport(payload) {
    const fn = callable('submitBugReport', { timeout: 60000 });
    const res = await fn(payload);
    return res.data;
  }

  async function fetchImage(reportId) {
    const fn = callable('getBugReportImage', { timeout: 60000 });
    const res = await fn({ reportId });
    return (res.data && res.data.dataUrl) || '';
  }

  async function updateStatus(reportId, statut, resolutionNote) {
    const fn = callable('updateBugReportStatus');
    const res = await fn({ reportId, statut, resolutionNote: resolutionNote ?? null });
    return res.data;
  }

  async function remove(reportId) {
    const fn = callable('deleteBugReport');
    const res = await fn({ reportId });
    return res.data;
  }

  return { reports, loading, bind, unbind, submitReport, fetchImage, updateStatus, remove };
});
